
<!--Navbar-->
<nav id="main-nav" class=" navbar navbar-expand-lg original-nav navbar-light pb-0 height">
    <div class="container-fluid">
    <!-- Navbar brand -->
    <a class="navbar-brand ps-md-4 me-auto pb-0 pt-0" routerLink="/{{businessID}}/users/home"><img height="30px" style="margin-top: -10px;" src="../../assets/images/formed_logo.png"> </a>
  
    <!-- Collapse button -->
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#basicExampleNav"
      aria-controls="basicExampleNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="line"></span>
      <span class="line"></span>
      <span class="line3"></span>
    </button>
  
    <!-- Collapsible content -->
  
    <div class="collapse navbar-collapse " id="basicExampleNav">
  
      <!-- Links -->
      <ul class="navbar-nav ms-auto">
        <li class="nav-item single-item p-2">
          <a class="nav-link" id="home" routerLink="/{{this.businessID}}/users/home">Työpöytä
          </a>
        </li>
        <li class="nav-item single-item p-2">
          <a class="nav-link" id="home" routerLink="/{{businessID}}/openings/standard">Työpaikat
          </a>
        </li>
        <li class="nav-item single-item p-2">
          <a class="nav-link" id="home" routerLink="/{{businessID}}/wishlists">Toiveet
          </a>
        </li>

        <li class="nav-item single-item p-2">
          <a class="nav-link" id="flow" routerLink="/{{businessID}}/messages">Viestit</a>
        </li>
      

        <li class="nav-item single-item p-2">
          <a class="nav-link" id="flow" routerLink="/{{businessID}}/company-details">Asetukset</a>
        </li>

        <li class="nav-item single-item p-2 ms-0 ms-md-4">
          <a class="nav-link ms-0 " (click)="logout()" id="logout-btn"><i class="fas fa-sign-out-alt"></i></a>
        </li>
  
      </ul>
      <!-- Links -->
  
    </div>
    <!-- Collapsible content -->
    </div>
  </nav>
  
  
  